import { includes, startsWith } from 'lodash'
import UserDecorator from 'decorators/user'
import Vue from 'vue'
import auth from 'utils/auth'
import store from 'vx/store'
import pace from './before/pace'

export default router => {
  router.beforeEach(pace)

  router.beforeEach((to, from, next) => {
    Vue.prototype.$previousRoute = from
    Vue.prototype.$user = new UserDecorator()

    const defineAuthorizedUser = () => {
      Vue.prototype.$user = store.getters['user/authorized']
    }

    const continueToNext = () => {
      next()
    }

    const redirectBasedOnConditions = () => {
      let user = store.getters['user/authorized']

      if (to.name === 'auth.logout') {
        next()

      // If the user is not valid and the route we are attempting to browse
      // to is NOT the "auth.details" route then we'll redirect them
      // back to the "auth.details" route as they are required to
      // fill out these details to become a valid user.
      } else if (!user.valid && to.name !== 'auth.details') {
        next({ 'name': 'auth.details' })

      // If the users email has not been verified and the route we are
      // attempting to browse is NOT the "auth.success" route then
      // we'll redirect them back to the "auth.success" route as
      // they are required to verify their email.
      } else if (user.valid && !user.email_verified && to.name !== 'auth.success') {
        next({ name: 'auth.success' })
      } else {
        next()
      }
    }

    // If route requires authentication attempt to authorize the logged in user
    // via their token if we do not have an authorized user already.
    if (to.matched.some(route => route.meta.requiresAuth === true)) {
      const redirectToLogin = () => {
        next({ name: 'auth.login', query: { redirect: to.path } })
      }

      auth.fromToken().then(defineAuthorizedUser).then(redirectBasedOnConditions).catch(redirectToLogin)

      // If the route does not require authentication then we'll still attempt to
      // authorize the user via any token and if they are authorized we'll send
      // them back to a determined page. Happens when they hit the login route
      // even though you're already logged in. If we can't log them in then
      // we'll simply continue on to what would most likely be the login.
    } else {
      const redirectBasedOnAuthorization = () => {
        if (includes(['auth.forgot'], to.name)) {
          auth.clearToken()
          next()
        } else if (includes(['auth.login'], to.name)) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      }

      auth.fromToken().then(defineAuthorizedUser).then(redirectBasedOnAuthorization).catch(continueToNext)
    }
  })

  router.beforeEach((to, from, next) => {
    const user = store.getters['user/authorized']
    const route = (name) => startsWith(to.name, name)
    const redirectToDashboard = () => next({ name: 'dashboard' })

    if (route('jobs') && !user.canManageJobs) {
      redirectToDashboard()
    } else if (route('locations') && !user.canManageLocations) {
      redirectToDashboard()
    } else if (route('trucks') && !user.canManageTrucks) {
      redirectToDashboard()
    } else if (route('drivers') && !user.canManageDrivers) {
      redirectToDashboard()
    } else if (route('loads') && !user.canManageLoads) {
      redirectToDashboard()
    } else if (route('load-check') && !user.canManageLoadChecks) {
      redirectToDashboard()
    } else if (route('invoices') && !user.canManageInvoices) {
      redirectToDashboard()
    } else if (route('payments') && !user.canManagePayments) {
      redirectToDashboard()
    } else if (route('reports') && !user.canManageReports) {
      redirectToDashboard()
    } else if (route('users') && !user.canManageUsers) {
      redirectToDashboard()
    } else if (route('settings') && !user.canManageSettings) {
      redirectToDashboard()
    } else if (route('job-board') && !user.canManageJobBoard) {
      redirectToDashboard()
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/before.js